import { Container } from "unstated";

export default class FiltersContainer extends Container {
  state = {
    values: {},
  };

  get hasFilters() {
    return Object.values(this.state.values).filter(Boolean).length > 0;
  }

  reset() {
    return this.setState({ values: {} });
  }

  set(delta) {
    return this.setState((prevState) => ({
      values: {
        ...prevState.values,
        ...delta,
      },
    }));
  }

  unset(key) {
    const { ...values } = this.state.values;
    delete values[key];
    return this.setState({ values });
  }

  validate(query) {
    const totalQuery = {
      ...query,
      ...this.state.values,
    };

    const hasBudget = totalQuery.budget?.length === 2;
    const hasCapacity = totalQuery.capacity;
    const hasDate = totalQuery.dates?.start && totalQuery.dates?.end;
    const hasTime = totalQuery.times?.start && totalQuery.times?.end;
    const isValid =
      (!hasDate && !hasTime) ||
      (hasBudget && hasDate && hasTime && hasCapacity);
    if (isValid) return {};

    return {
      capacity: !hasCapacity,
      dateAndTime: !hasDate || !hasTime,
    };
  }
}
